import { CompanyCreate } from './CompanyCreate'
import { CompanyEdit } from './CompanyEdit'
import { CompanyList } from './CompanyList'
import { CompanyShow } from './CompanyShow'

export { CompanyCreate, CompanyEdit, CompanyList, CompanyShow }
